import LinkGuide from '@/components/organisms/LinkGuide';
import ReqAddMarketContainer from '@/containers/market/ReqAddMarketContainer';
import { ROUTES } from '@/routes';
import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ReqAddMarketPage = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(ROUTES.market);
  };

  return (
    <div className=" flex h-full w-full  flex-1 flex-col gap-[16px] bg-gr-50 ">
      <div className="mx-auto flex h-full w-full max-w-[1680px] flex-1 flex-col gap-[16px] overflow-hidden overflow-y-scroll  p-[40px]">
        <div className=" flex h-fit w-full flex-wrap gap-[18px] ">
          <div className="flex flex-1 flex-col">
            <div className="sticky top-0 w-full ">
              <button
                onClick={handleBack}
                className="mb-[24px] flex w-full gap-[12px]  text-gr-900 Title2S24"
              >
                <ChevronLeft className="h-8 w-8" />
                뒤로가기
              </button>
              <ReqAddMarketContainer />
            </div>
          </div>
          <div className="w-full flex-1 md:mt-[56px] ">
            <div className=" space-y-[30px]">
              <LinkGuide
                guide={{
                  type: 'linkGuide',
                  contents: {
                    title: '마켓 추가를 위해 계정이 필요해요',
                    mainText: (
                      <p>
                        연동 가능 스토어를 지속적으로 확대 중입니다.
                        <br />
                        빠른 시일 내에 마켓을 추가할 수 있도록 셀러님의 계정을 셀러박스에게
                        알려주세요!
                      </p>
                    ),
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReqAddMarketPage;

//  <div className=" flex h-fit w-full flex-wrap gap-[18px] ">
//     <div className="mt-[14px] flex space-x-[30px]">
//       <div className="pl-[6px]">
//         <ReqAddMarketContainer />
//         <InquiryButton className="mt-[24px]" />
//       </div>
//       <div>
//         <LinkGuide
//           guide={{
//             type: 'linkGuide',
//             contents: {
//               title: '마켓 추가를 위해 계정이 필요해요',
//               mainText: (
//                 <p>
//                   연동 가능 스토어를 지속적으로 확대 중입니다.
//                   <br />
//                   빠른 시일 내에 마켓을 추가할 수 있도록 셀러님의 계정을 셀러박스에게 알려주세요!
//                 </p>
//               ),
//             },
//           }}
//         />
//         <div className="mt-[30px]">
//           <PromotionSellkeyCard />
//         </div>
//       </div>
//     </div>
//   </div>
